import ApiService from "../api";

export default class SolicitacaoAdminService extends ApiService {

    constructor() {
        super('/api/solicitacoes/admin')
    }

    listar(tipoProcesso, status, dataInicial, dataFinal) {
        var params = "?"
        if (tipoProcesso) {
            params += `tipoProcesso=${tipoProcesso}`
        }
        if (status) {
            params += `${params.length > 1 ? '&' : ''}status=${status}`
        }
        if (dataInicial) {
            params += `${params.length > 1 ? '&' : ''}dataInicial=${dataInicial}`
        }
        if (dataFinal) {
            params += `${params.length > 1 ? '&' : ''}dataFinal=${dataFinal}`
        }
        return this.get(params)
    }

    usuariosElegiveis(id) {
        return this.get(`/${id}/usuarios-elegiveis-responsavel`)
    }

    alterarResponsavel(id, novoUsuarioId, motivo) {
        return this.put(`/${id}/responsavel`, { novoUsuarioId, motivo })
    }

    eliminar(id, motivo) {
        return this.post(`/${id}/eliminar`, { motivo })
    }
}
